/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sold: NonNullable<unknown> }} Ticketstaken1Inputs */

const en_ticketstaken1 = /** @type {(inputs: Ticketstaken1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sold} taken`)
};

const de_ticketstaken1 = /** @type {(inputs: Ticketstaken1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sold} vergeben`)
};

/**
* | output |
* | --- |
* | "{sold} taken" |
*
* @param {Ticketstaken1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketstaken1 = /** @type {((inputs: Ticketstaken1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketstaken1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketstaken1(inputs)
	return de_ticketstaken1(inputs)
});
export { ticketstaken1 as "ticketsTaken" }